export const WHATSAPP_VIDEO_CLIP_DURATION_SECONDS = 45;
export const DEFAULT_WHATSAPP_CLIP_SELECTION = 'first';

export const normalizeWhatsAppClipSelection = (value) => {
  const normalized = String(value || '').trim().toLowerCase();

  if (['first', 'start', 'beginning', 'head'].includes(normalized)) {
    return 'first';
  }

  if (['last', 'end', 'tail'].includes(normalized)) {
    return 'last';
  }

  return null;
};

export const formatWhatsAppClipSelection = (selection) => (
  selection === 'first'
    ? `First ${WHATSAPP_VIDEO_CLIP_DURATION_SECONDS} seconds`
    : `Last ${WHATSAPP_VIDEO_CLIP_DURATION_SECONDS} seconds`
);

export function promptForWhatsAppClipSelection() {
  if (typeof window === 'undefined') {
    return { cancelled: false, clipSelection: DEFAULT_WHATSAPP_CLIP_SELECTION };
  }

  while (true) {
    const response = window.prompt(
      `Which part of the video should be sent?\n\nType "first" for the first ${WHATSAPP_VIDEO_CLIP_DURATION_SECONDS} seconds or "last" for the last ${WHATSAPP_VIDEO_CLIP_DURATION_SECONDS} seconds.`,
      DEFAULT_WHATSAPP_CLIP_SELECTION,
    );

    if (response === null) {
      return { cancelled: true, clipSelection: null };
    }

    const clipSelection = normalizeWhatsAppClipSelection(response);
    if (clipSelection) {
      return { cancelled: false, clipSelection };
    }

    window.alert('Please type "first" or "last".');
  }
}
